export enum CampaignAssignmentTypeEnum {
  SINGLE_OPT = 'single-opt',
  DOUBLE_OPT = 'double-opt'
}
